import { useMemo } from 'react';

const COLORS = ['#FFD700', '#C75B3A', '#22C55E', '#D4755A', '#6B8F5E', '#F59E0B'];

function Particle({ style, color, delay, duration }) {
  return (
    <span
      className="confetti-particle absolute w-2 h-2 rounded-sm pointer-events-none"
      style={{
        backgroundColor: color,
        left: style.left,
        top: style.top,
        animationDelay: `${delay}ms`,
        animationDuration: `${duration}ms`,
      }}
    />
  );
}

export default function Confetti({ count = 40, className = '' }) {
  const particles = useMemo(
    () =>
      Array.from({ length: count }, (_, i) => ({
        id: i,
        left: `${Math.random() * 100}%`,
        top: `${-10 - Math.random() * 20}%`,
        color: COLORS[i % COLORS.length],
        delay: Math.random() * 400,
        duration: 1200 + Math.random() * 800,
      })),
    [count],
  );

  return (
    <div className={`absolute inset-0 overflow-hidden pointer-events-none ${className}`} aria-hidden="true">
      {particles.map((p) => (
        <Particle key={p.id} style={{ left: p.left, top: p.top }} color={p.color} delay={p.delay} duration={p.duration} />
      ))}
    </div>
  );
}
